export default __webpack_public_path__ + "static/media/Labirynth-04.d613246b.svg";